registerComponent("pages/register", async function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * 316 linhas viraram estas. Tudo que era jQuery Validate (`datebr`, `taxId`,
 * `cellphone`, `cpfBR`, `minWords`, `equalTo`, a tabela de mensagens PT/EN, o
 * `highlight`/`unhighlight`/`errorPlacement`), jquery.mask e `$.post` está em
 * `Asa.formulario`; aqui fica só o que é do cadastro — o segmento, as três
 * telas e o evento do marketing.
 *
 * O que MUDA de comportamento, e por quê:
 *
 * - **O envio manda `Accept: application/json`** (é `Asa.formulario` quem
 *   manda, e não é opção). A rota `/seja-nosso-cliente` é do contrato
 *   `redirect` — ela responde **302 mesmo com o cabeçalho**, porque o
 *   `shouldRenderJsonWhen` de `bootstrap/app.php` substitui o `expectsJson()`
 *   do framework (defeito de backend registrado no relatório do 5c e no
 *   `FormsContractTest`). O `redirect: 'manual'` do `Asa.formulario` faz esse
 *   302 cair no caminho de erro, que é onde o `$.post` com `dataType: 'json'`
 *   de 2020 caía por acidente: a tela de erro, não a de sucesso.
 * - `keyup` → `input` nos campos (ver `blocks/input`).
 * - Os dois `console.log` de depuração do idioma saíram.
 *
 * O que NÃO muda: o corpo do POST. Nomes, ordem e valores MASCARADOS (data,
 * CPF e telefone) são os que estão gravados nos leads em produção, e a fixture
 * `tests/Fixtures/site-forms/register.json` é a prova pelo lado do servidor.
 *
 * ⚠️ `segments[]` vai UMA vez, não duas. Os três `blocks/radio` do segmento
 * ficam FORA do `<form id="formContact">` no Blade (irmãos, não filhos), então
 * nem o `$(form).serialize()` de 2020 nem o `new FormData(form)` de hoje os
 * enxergam — e é justamente por isso que o legado acrescentava `segments[]=3`
 * à mão. O arquivo da Fase 6 supõe duplicação ("o marcado pelo usuário + o `3`
 * que o JS acrescenta"); medido, não há. Correção 106 do programa.
 */

const form = component.querySelector('#formContact');
const primeiraEtapa = component.querySelector('.first-step');
const sucesso = component.querySelector('.successful');
const erro = component.querySelector('.error-screen');
const voltar = component.querySelector('.link-back-error');
const segmentos = Array.from(component.querySelectorAll('[name="segments[]"]'));
const caixaDoFormulario = component.querySelector('[data-item="form"]');
const caixaDoQrCode = component.querySelector('[data-item="qrcode"]');

const isEn = (document.documentElement.lang || '').toLowerCase().startsWith('en');
const isPt = !isEn;

/*
 | ⚠️ `display: block`, não `''`, para `.successful`, `.error-screen` e as duas
 | `.item-content`: as quatro nascem `display: none` PELA FOLHA, e o `.show()`
 | do jQuery caía no display padrão da tag (`block` para `div`), não no `''`
 | que devolveria o `none` da folha. É a correção 67, a mesma do 5b.
 |
 | O `.first-step` é o contrário: não tem `display` na folha, e quem escreveu o
 | `none` foi o JS — ali `''` é o certo.
 */
const mostrarTela = (tela) => {
    primeiraEtapa.style.display = tela === 'form' ? '' : 'none';
    sucesso.style.display = tela === 'sucesso' ? 'block' : 'none';
    erro.style.display = tela === 'erro' ? 'block' : 'none';
};

const mostrarCaixa = (qual) => {
    caixaDoFormulario.style.display = qual === 'form' ? 'block' : 'none';
    caixaDoQrCode.style.display = qual === 'qrcode' ? 'block' : 'none';
};

/**
 * O telefone.
 *
 * PT: a máscara dinâmica de 2020 — 11 dígitos viram `(00) 00000-0000`, menos
 * do que isso fica em `(00) 0000-00009`.
 *
 * EN: o telefone estrangeiro não tem formato fixo, e 2020 só filtrava os não
 * dígitos em tempo real. Uma máscara de N tokens `0` é esse filtro. É o mesmo
 * par que `sections/newsletter` usa.
 */
const mascaraDoTelefone = isPt
    ? (valor) => (valor.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009')
    : (valor) => '0'.repeat(Math.max(1, valor.replace(/\D/g, '').length));

const telefone = form.querySelector('[name="phone"]');

if (telefone && isEn) {
    // Teclado numérico no celular; era o mesmo atributo, posto pelo mesmo JS.
    telefone.setAttribute('inputmode', 'numeric');
}

const formulario = Asa.formulario(form, {
    /*
     | ⚠️ `location.href`, e NÃO o `action` do `<form>` — ele não tem `action`.
     | Sem isto o `Asa.formulario` resolveria `''` contra o `document.baseURI`,
     | que é o `<base href>` do layout legado: o POST iria para a RAIZ do site
     | em vez da página, e a raiz não tem rota de POST. O legado postava em
     | `window.location.href`; é o mesmo destino, à letra.
     */
    action: window.location.href,
    regras: {
        name: { minPalavras: 2 },
        birth_date: { dataBr: true },
        email: { email: true },
        email_confirmation: { email: true, confirmar: 'email' },
        // `cpfBR` em pt, `taxId` (o EIN americano) em en — as duas do legado,
        // uma ligada e a outra desligada, como o `(isPt) ? true : false` fazia.
        cpf: { cpf: isPt, taxId: isEn },
        phone: { minlength: 7, celular: isPt },
    },
    mensagens: {
        name: { minPalavras: isEn ? 'Provide first and last name.' : 'Informe nome e sobrenome.' },
        birth_date: { dataBr: isEn ? 'Provide a valid date.' : 'Informe uma data válida.' },
        cpf: { cpf: isEn ? 'Provide a valid CPF.' : 'Informe um CPF válido.' },
        email_confirmation: {
            confirmar: isEn ? 'The e-mails do not match.' : 'Os e-mails informados não coincidem.',
        },
        phone: {
            minlength: isEn ? 'Provide a valid mobile phone number.' : 'Informe um celular válido.',
        },
    },
    mascaras: {
        birth_date: '00/00/0000',
        cpf: isPt ? '000.000.000-00' : '99-9999999',
        phone: mascaraDoTelefone,
    },
    /*
     | O `formDataArr.push` de 2020, e com ele a ORDEM: o `3` entra DEPOIS dos
     | campos do formulário. O servidor manda o e-mail para
     | `mail.recipients.register.{segments[0]}`, então trocar `append` por `set`
     | ou inverter a ordem mudaria o destinatário.
     */
    antesDeEnviar: (dados) => dados.append('segments[]', '3'),
    /*
     | O `hasError` do `handleValidation()` de 2020: sem segmento marcado o
     | botão fica travado, mesmo com os seis campos válidos. Os radios estão
     | fora do `<form>`, daí a busca partir do `component`.
     */
    habilitarEnvio: () => component.querySelector('[name="segments[]"]:checked') !== null,
});

/*
 | O segmento. Só "AsaEMPRESAS" (`id: 3`) abre o formulário; os outros dois
 | mandam para o app — QR code no desktop, loja no celular.
 |
 | ⚠️ O `window.open` fica SÍNCRONO dentro do `change`: qualquer `await` antes
 | dele o transforma em popup bloqueado.
 |
 | ⚠️ `Asa.legado.celular` (767), não `Asa.celular` (768): o `Is.mobile.ANY()`
 | de 2020 era UA, e o degrau que o CSS desta página usa é o do legado.
 */
segmentos.forEach((segmento) => {
    segmento.addEventListener('change', function () {
        if (this.value === '3') {
            mostrarCaixa('form');
            Asa.legado.rolarPara(caixaDoFormulario);
        } else if (Asa.legado.celular.matches) {
            window.open('https://www.asa.com.br/abrasuaconta/lojas', '_blank');
            mostrarCaixa(null);
        } else {
            mostrarCaixa('qrcode');
        }

        formulario.atualizarEnvio();
    });

    // O `$checks.on('click')` do legado, que destravava o botão sem esperar o
    // `change` — em radio os dois disparam, e reavaliar duas vezes não custa.
    segmento.addEventListener('click', () => formulario.atualizarEnvio());
});

/*
 | A tela de erro e o caminho de volta. O legado reabilitava o submit à mão
 | porque, se o AJAX chegou a disparar, a validação já tinha passado e o
 | `.first-step` oculto impediu qualquer alteração. Aqui `atualizarEnvio()`
 | reavalia os campos de verdade e chega ao mesmo lugar, sem supor nada.
 */
if (voltar) {
    voltar.addEventListener('click', function (evento) {
        evento.preventDefault();

        mostrarTela('form');
        formulario.atualizarEnvio();
        Asa.legado.rolarPara(0);
    });
}

form.addEventListener('formulario:sucesso', function () {
    Asa.legado.rolarPara(0);
    mostrarTela('sucesso');
    form.reset();
    formulario.atualizarEnvio();

    // Contrato com o marketing: era `$document.trigger('remoteTrack', [categoria, acao])`.
    Asa.rastrear('Seja_nosso_cliente', 'cliente_cadastrado');
});

form.addEventListener('formulario:erro', /** @param {CustomEvent} evento */ function (evento) {
    /*
     | 422 com erros POR CAMPO não troca de tela: as mensagens já estão nas
     | `label.error` ao lado do campo, e esconder o formulário esconderia
     | justamente a informação nova. Hoje esta rota nunca chega aqui com
     | `erros` — ela responde 302 —, mas chegará no dia em que o defeito do
     | `shouldRenderJsonWhen` for consertado, e então o caminho já existe.
     */
    if (evento.detail && evento.detail.erros) {
        return;
    }

    Asa.legado.rolarPara(0);
    mostrarTela('erro');
});

});
